<template>
  <v-dialog v-model="dialogVisible" max-width="400px">
    <v-card>
      <template #title>
        <span class="text-primary">{{ props.headerText }}</span>
      </template>
      <template #text>
        <v-list>
          <v-list-item
            v-for="(file, index) in props.filesAvailable"
            :key="index"
            :title="t(`billing.invoices.invoiceDisplayTypes.${file.type?.toLowerCase()}`)"
          >
            <template #prepend>
              <v-icon color="primary">mdi-file-pdf-box</v-icon>
            </template>

            <template #append>
              <v-icon size="18" color="secondary" @click="startDownload(file.downloadUrl!)">
                mdi-download
              </v-icon>
            </template>
          </v-list-item>
        </v-list>
      </template>
    </v-card>
  </v-dialog>
</template>

<script setup lang="ts">
import { DownloadInvoice200ResponseInner } from "@tableyeti/merchant-service";
import { ref, watch } from "vue";
import { useI18n } from "vue-i18n";
const { t } = useI18n();

const props = withDefaults(
  defineProps<{
    showDownloadOptions?: boolean;
    filesAvailable?: DownloadInvoice200ResponseInner[];
    headerText?: string;
  }>(),
  { showDownloadOptions: false, filesAvailable: () => [], headerText: "" },
);
const dialogVisible = ref(props.showDownloadOptions);

watch(
  () => props.showDownloadOptions,
  (newVal) => {
    dialogVisible.value = newVal;
    if (newVal) {
      // Pre signed links only last for 30 seconds.
      // Close modal after 20s to prevent user clicking an expired link
      setTimeout(() => {
        dialogVisible.value = false;
      }, 20000);
    }
  },
);

const startDownload = (url: string) => {
  window.open(url, "_self");
};
</script>
